import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export const tableRowHeight = 38;
export const tableRowHeightSM = 50;
export const tableHeadRowHeight = 46;
export const paginationRowHeight = 46;

export default makeStyles((theme: MuiTheme) => ({
  root: {
    width: "100%",
    height: "100%",
    position: "relative"
  },
  cta: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(255, 255, 255, 0.2)"
  },
  ctaBg: {
    width: 350,
    height: 350,
    position: "absolute",
    zIndex: 0,
    opacity: 0.05
  },
  ctaContent: {
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  ctaTitle: {
    color: theme.palette.text.secondary,
    textTransform: "capitalize",
    padding: "0 16px",
    textAlign: "center"
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    overflow: "hidden",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxWidth: "100%"
    }
  },
  table: {
    flex: "auto",
    height: "100%"
  },
  tableHead: {
    maxHeight: tableHeadRowHeight,
    "& .MuiTableRow-root:last-child .MuiTableCell-root": {
      borderBottom: `1px solid ${theme.palette.text.hint}`,
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        borderBottom: "none"
      }
    },
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  tableHeaderRow: {
    height: tableHeadRowHeight,
    padding: "0 16px",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "0 16px",
      display: "grid",
      gridTemplateColumns: "2fr 3fr 4fr 5fr 1.5fr",
      gridColumnGap: 12,
      alignItems: "center"
    }
  },
  tableHeadCell: {
    color: theme.palette.text.secondary,
    background: theme.palette.common.white,
    whiteSpace: "nowrap",
    "&:last-child": {
      textAlign: "center"
    },
    padding: "0 16px",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "0"
    }
  },
  sortIcon: {
    marginLeft: 14
  },
  dark: {
    color: theme.palette.text.secondary
  },
  tableBody: {
    position: "relative",
    "& .MuiTableRow-root:last-child .MuiTableCell-root": {
      borderBottom: "1px solid #eeeeee",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        borderBottom: "none"
      }
    }
  },
  tableRowWrapper: {
    width: "100%"
  },
  tableRow: {
    height: tableRowHeight,
    cursor: "pointer",
    "& .MuiTableCell-root": {
      padding: "4px 16px",
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        padding: "4px 0"
      }
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      height: tableRowHeightSM,
      borderBottom: "1px solid #eeeeee",
      "& .MuiTableCell-root": {
        padding: 0,
        whiteSpace: "nowrap",
        maxWidth: 120,
        textOverflow: "ellipsis",
        overflow: "hidden",
        borderBottom: "none"
      }
    },
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "0 16px",
      display: "grid",
      gridTemplateColumns: "2fr 3fr 4fr 5fr 1.5fr",
      gridColumnGap: 12,
      alignItems: "center"
    }
  },
  tableRowFiller: {
    "&.MuiTableRow-root:nth-child(2n)": {
      background: theme.palette.common.white
    }
  },
  tablePaginationCell: {
    padding: 0,
    height: tableHeadRowHeight
  },
  mobileOpenTab: {
    gridTemplateColumns: "2fr 3fr 4fr 5fr 1.5fr"
  },
  tableRowActive: {
    "& .MuiTableCell-root": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: theme.palette.text.primary
    }
  },
  wrench: {
    fontSize: 12,
    marginRight: 8
  },
  tableCell: {
    maxHeight: tableRowHeight,
    lineHeight: 1
  },
  mobileTableCell: {},
  ellipsis: {
    textOverflow: "ellipsis"
  },
  tableCellDate: {
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center"
    }
  },
  tableCellStatus: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    maxWidth: 148,
    borderLeft: "1px solid #eeeeee"
  },
  actionButtons: {
    display: "flex",
    justifyContent: "center",
    "& .MuiButtonBase-root:not(:last-child)": {
      marginRight: 15
    }
  },
  actionButton: {
    opacity: 0.6,
    "&:hover": {
      opacity: 1
    }
  },
  assignButton: {
    color: "#436AB5",
    "&:hover": {
      boxShadow: "none"
    }
  },
  closeButton: {
    color: "#998765"
  },
  detailsButton: {
    color: "#333333"
  },
  undoButton: {
    transform: "scaleX(-1)",
    color: "#d92e44"
  },
  completeButton: {
    color: theme.palette.secondary.dark,
    "& .MuiSvgIcon-root": {
      width: 24,
      height: 20
    }
  },
  reOpenButton: {
    color: "#998765",
    cursor: "pointer"
  },
  actionButtonActive: {
    opacity: 1
  },
  pagination: {
    height: paginationRowHeight,
    padding: 10,
    borderTop: `1px solid ${theme.palette.text.hint}`
  },
  actionsCell: {
    borderLeft: "1px solid #eeeeee",
    width: "1%",
    whiteSpace: "nowrap"
  },
  hideDownXS600: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  dotsButton: {
    color: theme.palette.text.primary,
    padding: 0,
    marginRight: -3,
    "&.active": {
      color: "rgba(97, 198, 158, 1)"
    }
  },
  clearButton: {
    width: 130,
    height: 30,
    color: theme.palette.text.secondary,
    borderRadius: 2,
    marginTop: 12,
    textTransform: "capitalize",
    padding: "2px 2px 0",
    border: "1px solid #7f7f7f",
    fontSize: 13
  }
}));
